import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Footer } from '../components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { MessageSquareText, HelpCircle, Mail } from 'lucide-react';
import HelpFAQs from '../components/HelpFAQs';
import HelpChatbot from '../components/HelpChatbot';
import HelpContactForm from '../components/HelpContactForm';

const HelpPage = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('chatbot');

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-amber-50/30 to-rose-50/20" data-testid="help-page">
      <Navbar />
      <main className="max-w-6xl mx-auto px-4 pt-24 pb-12">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>
            {t('help.title', 'Centro de ayuda')}
          </h1>
          <p className="text-slate-600 mt-2">
            {t('help.subtitle', 'Resuelve dudas o contáctanos directamente.')}
          </p>
        </div>

        <Tabs value={tab} onValueChange={setTab} className="w-full">
          <TabsList className="grid grid-cols-3 w-full md:w-auto mb-6 bg-white border p-1 rounded-xl shadow-sm">
            <TabsTrigger value="chatbot" data-testid="help-tab-chatbot" className="gap-2 data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-rose-500 data-[state=active]:text-white">
              <MessageSquareText className="w-4 h-4" />
              <span className="hidden sm:inline">{t('help.tabs.chatbot', 'Asistente IA')}</span>
            </TabsTrigger>
            <TabsTrigger value="faqs" data-testid="help-tab-faqs" className="gap-2 data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-rose-500 data-[state=active]:text-white">
              <HelpCircle className="w-4 h-4" />
              <span className="hidden sm:inline">{t('help.tabs.faqs', 'Preguntas frecuentes')}</span>
            </TabsTrigger>
            <TabsTrigger value="contact" data-testid="help-tab-contact" className="gap-2 data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-rose-500 data-[state=active]:text-white">
              <Mail className="w-4 h-4" />
              <span className="hidden sm:inline">{t('help.tabs.contact', 'Contacto')}</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="chatbot" className="mt-0">
            <div className="bg-white rounded-2xl p-1 shadow-sm border">
              <HelpChatbot />
            </div>
          </TabsContent>

          <TabsContent value="faqs" className="mt-0">
            <div className="bg-white rounded-2xl p-6 border shadow-sm">
              <HelpFAQs />
            </div>
          </TabsContent>

          <TabsContent value="contact" className="mt-0">
            <div className="bg-white rounded-2xl p-6 md:p-8 border shadow-sm">
              <HelpContactForm />
            </div>
          </TabsContent>
        </Tabs>
      </main>
      <Footer />
    </div>
  );
};

export default HelpPage;
